import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState, useEffect } from "react";
import "./gallery.css";
import ImageModal from "./ImageModal";

export default function EventImages(props) {
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    centerPadding: "60px",
    slidesToShow: 1,
    speed: 500,
    rows: 2,
    slidesPerRow: 3,
    autoplay: true,
    speed: 800,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          rows: 4,
          slidesPerRow: 1,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 620,
        settings: {
          rows: 3,
          slidesPerRow: 1,
          slidesToShow: 1,
        },
      },
    ],
  };

  const [images, setImages] = useState();

  useEffect(() => {
    fetch("/events")
      .then((response) => response.json())
      .then((response) => setImages(response));
  }, []);

  var evtImage = [];

  if (images) {
    images.map((image) => {
      if (image.eventName.toLowerCase() === props.name.toLowerCase()) {
        evtImage.push(image.eventImage);
      } else if (props.name === "All") {
        evtImage.push(image.eventImage);
      }
    });
  }

  const [openModal, setOpenModal] = useState(false);

  const [modalImagePath, setModalImagePath] = useState();

  return (
    <div className="event_images">
      <Slider {...settings}>
        {evtImage &&
          evtImage.map((ei) =>
            ei ? (
              <img
                onClick={() => {
                  setOpenModal(true);
                  setModalImagePath(ei.path);
                }}
                key={ei.path}
                style={{ width: "100%", height: "100px", cursor: "pointer" }}
                src={`https://skylark-website-images.s3.ap-south-1.amazonaws.com/event-images/${ei.path}`}
              />
            ) : (
              ""
            )
          )}

        {/* <div className="event_images">
        {evtImage && evtImage.map((ei)=>(       
            <img src={ei ? `https://freelance-project-1-bucket.s3.ap-south-1.amazonaws.com/event-images/${ei.path}` : ''}/>  
        ))}
        </div>

         */}
      </Slider>
      <ImageModal
        isOpen={openModal}
        closeModal={() => setOpenModal(false)}
        modalImagePath={modalImagePath}
      />
    </div>
  );
}
